module.exports = {
	"$version": 8,
	"$root": {
		"version": {
			"required": true,
			"type": "enum",
			"values": [
				8
			]
		},
		"name": {
			"type": "string"
		},
		"metadata": {
			"type": "*"
		},
		"center": {
			"type": "array",
			"value": "number"
		},
		"zoom": {
			"type": "number"
		},
		"bearing": {
			"type": "number",
			"default": 0,
			"period": 360,
			"units": "degrees"
		},
		"pitch": {
			"type": "number",
			"default": 0,
			"units": "degrees"
		},
		"sources": {
			"required": true,
			"type": "sources"
		},
		"sprite": {
			"type": "string"
		},
		"glyphs": {
			"type": "string"
		},
		"transition": {
			"type": "transition"
		},
		"layers": {
			"required": true,
			"type": "array",
			"value": "layer"
		}
	},
	"sources": {
		"*": {
			"type": "source"
		}
	},
	"source": [
		"source_tile",
		"source_geojson",
		"source_video",
		"source_image"
	],
	"source_tile": {
		"type": {
			"required": true,
			"type": "enum",
			"values": [
				"vector",
				"raster"
			]
		},
		"url": {
			"type": "string"
		},
		"tiles": {
			"type": "array",
			"value": "string"
		},
		"minzoom": {
			"type": "number",
			"default": 0
		},
		"maxzoom": {
			"type": "number",
			"default": 22
		},
		"tileSize": {
			"type": "number",
			"default": 512,
			"units": "pixels"
		},
		"*": {
			"type": "*"
		}
	},
	"source_geojson": {
		"type": {
			"required": true,
			"type": "enum",
			"values": [
				"geojson"
			]
		},
		"data": {
			"type": "*"
		},
		"maxzoom": {
			"type": "number",
			"default": 14
		},
		"buffer": {
			"type": "number",
			"default": 64
		},
		"tolerance": {
			"type": "number",
			"default": 3
		},
		"cluster": {
			"type": "boolean",
			"default": false
		},
		"clusterRadius": {
			"type": "number",
			"default": 400
		},
		"clusterMaxZoom": {
			"type": "number"
		}
	},
	"source_video": {
		"type": {
			"required": true,
			"type": "enum",
			"values": [
				"video"
			]
		},
		"urls": {
			"required": true,
			"type": "array",
			"value": "string"
		},
		"coordinates": {
			"required": true,
			"type": "array",
			"length": 4,
			"value": {
				"type": "array",
				"length": 2,
				"value": "number"
			}
		}
	},
	"source_image": {
		"type": {
			"required": true,
			"type": "enum",
			"values": [
				"image"
			]
		},
		"url": {
			"required": true,
			"type": "string"
		},
		"coordinates": {
			"required": true,
			"type": "array",
			"length": 4,
			"value": {
				"type": "array",
				"length": 2,
				"value": "number"
			}
		}
	},
	"layer": {
		"id": {
			"type": "string",
			"required": true
		},
		"type": {
			"type": "enum",
			"values": [
				"fill",
				"line",
				"symbol",
				"circle",
				"raster",
				"background"
			]
		},
		"metadata": {
			"type": "*"
		},
		"ref": {
			"type": "string"
		},
		"source": {
			"type": "string"
		},
		"source-layer": {
			"type": "string"
		},
		"minzoom": {
			"type": "number",
			"minimum": 0,
			"maximum": 22
		},
		"maxzoom": {
			"type": "number",
			"minimum": 0,
			"maximum": 22
		},
		"interactive": {
			"type": "boolean",
			"default": false
		},
		"filter": {
			"type": "filter"
		},
		"layout": {
			"type": "layout"
		},
		"paint": {
			"type": "paint"
		},
		"paint.*": {
			"type": "paint"
		}
	},
	"layout": [
		"layout_fill",
		"layout_line",
		"layout_circle",
		"layout_symbol",
		"layout_raster",
		"layout_background"
	],
	"layout_background": {
		"visibility": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"values": [
				"visible",
				"none"
			],
			"default": "visible"
		}
	},
	"layout_fill": {
		"visibility": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"values": [
				"visible",
				"none"
			],
			"default": "visible"
		}
	},
	"layout_circle": {
		"visibility": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"values": [
				"visible",
				"none"
			],
			"default": "visible"
		}
	},
	"layout_line": {
		"line-cap": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"butt",
				"round",
				"square"
			],
			"default": "butt"
		},
		"line-join": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"bevel",
				"round",
				"miter"
			],
			"default": "miter"
		},
		"line-miter-limit": {
			"type": "number",
			"default": 2,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				{
					"line-join": "miter"
				}
			]
		},
		"line-round-limit": {
			"type": "number",
			"default": 1.05,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				{
					"line-join": "round"
				}
			]
		},
		"visibility": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"values": [
				"visible",
				"none"
			],
			"default": "visible"
		}
	},
	"layout_symbol": {
		"symbol-placement": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"point",
				"line"
			],
			"default": "point"
		},
		"symbol-spacing": {
			"type": "number",
			"default": 250,
			"minimum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"units": "pixels",
			"requires": [
				{
					"symbol-placement": "line"
				}
			]
		},
		"symbol-avoid-edges": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false
		},
		"icon-allow-overlap": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"icon-image"
			]
		},
		"icon-ignore-placement": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"icon-image"
			]
		},
		"icon-optional": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"icon-image",
				"text-field"
			]
		},
		"icon-rotation-alignment": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "viewport",
			"requires": [
				"icon-image"
			]
		},
		"icon-size": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"icon-image"
			]
		},
		"icon-text-fit": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": false,
			"values": [
				"none",
				"both",
				"width",
				"height"
			],
			"default": "none",
			"requires": [
				"icon-image",
				"text-field"
			]
		},
		"icon-text-fit-padding": {
			"type": "array",
			"value": "number",
			"length": 4,
			"default": [
				0,
				0,
				0,
				0
			],
			"units": "pixels",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"icon-image",
				"icon-text-fit",
				"text-field"
			]
		},
		"icon-image": {
			"type": "string",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"tokens": true
		},
		"icon-rotate": {
			"type": "number",
			"default": 0,
			"period": 360,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"units": "degrees",
			"requires": [
				"icon-image"
			]
		},
		"icon-padding": {
			"type": "number",
			"default": 2,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"units": "pixels",
			"requires": [
				"icon-image"
			]
		},
		"icon-keep-upright": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"icon-image",
				{
					"icon-rotation-alignment": "map"
				},
				{
					"symbol-placement": "line"
				}
			]
		},
		"icon-offset": {
			"type": "array",
			"value": "number",
			"length": 2,
			"default": [
				0,
				0
			],
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"icon-image"
			]
		},
		"text-pitch-alignment": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"requires": [
				"text-field"
			]
		},
		"text-rotation-alignment": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "viewport",
			"requires": [
				"text-field"
			]
		},
		"text-field": {
			"type": "string",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": "",
			"tokens": true
		},
		"text-font": {
			"type": "array",
			"value": "string",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": [
				"Open Sans Regular",
				"Arial Unicode MS Regular"
			],
			"requires": [
				"text-field"
			]
		},
		"text-size": {
			"type": "number",
			"default": 16,
			"minimum": 0,
			"units": "pixels",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field"
			]
		},
		"text-max-width": {
			"type": "number",
			"default": 10,
			"minimum": 0,
			"units": "em",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field"
			]
		},
		"text-line-height": {
			"type": "number",
			"default": 1.2,
			"units": "em",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field"
			]
		},
		"text-letter-spacing": {
			"type": "number",
			"default": 0,
			"units": "em",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field"
			]
		},
		"text-justify": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"left",
				"center",
				"right"
			],
			"default": "center",
			"requires": [
				"text-field"
			]
		},
		"text-anchor": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"center",
				"left",
				"right",
				"top",
				"bottom",
				"top-left",
				"top-right",
				"bottom-left",
				"bottom-right"
			],
			"default": "center",
			"requires": [
				"text-field"
			]
		},
		"text-max-angle": {
			"type": "number",
			"default": 45,
			"units": "degrees",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field",
				{
					"symbol-placement": "line"
				}
			]
		},
		"text-rotate": {
			"type": "number",
			"default": 0,
			"period": 360,
			"units": "degrees",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field"
			]
		},
		"text-padding": {
			"type": "number",
			"default": 2,
			"minimum": 0,
			"units": "pixels",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"requires": [
				"text-field"
			]
		},
		"text-keep-upright": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": true,
			"requires": [
				"text-field",
				{
					"text-rotation-alignment": "map"
				},
				{
					"symbol-placement": "line"
				}
			]
		},
		"text-transform": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"none",
				"uppercase",
				"lowercase"
			],
			"default": "none",
			"requires": [
				"text-field"
			]
		},
		"text-offset": {
			"type": "array",
			"value": "number",
			"units": "ems",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"length": 2,
			"default": [
				0,
				0
			],
			"requires": [
				"text-field"
			]
		},
		"text-allow-overlap": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"text-field"
			]
		},
		"text-ignore-placement": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"text-field"
			]
		},
		"text-optional": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": false,
			"requires": [
				"text-field",
				"icon-image"
			]
		},
		"visibility": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"values": [
				"visible",
				"none"
			],
			"default": "visible"
		}
	},
	"layout_raster": {
		"visibility": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"values": [
				"visible",
				"none"
			],
			"default": "visible"
		}
	},
	"filter": {
		"type": "array",
		"value": "*"
	},
	"filter_operator": {
		"type": "enum",
		"values": [
			"==",
			"!=",
			">",
			">=",
			"<",
			"<=",
			"in",
			"!in",
			"all",
			"any",
			"none",
			"has",
			"!has"
		]
	},
	"geometry_type": {
		"type": "enum",
		"values": [
			"Point",
			"LineString",
			"Polygon"
		]
	},
	"color_operation": {
		"type": "enum",
		"values": [
			"lighten",
			"saturate",
			"spin",
			"fade",
			"mix"
		]
	},
	"function": {
		"stops": {
			"type": "array",
			"required": true,
			"value": "function_stop"
		},
		"base": {
			"type": "number",
			"default": 1,
			"minimum": 0
		},
		"property": {
			"type": "string",
			"default": "$zoom"
		},
		"type": {
			"type": "enum",
			"values": [
				"exponential",
				"interval",
				"categorical"
			],
			"default": "exponential"
		}
	},
	"function_stop": {
		"type": "array",
		"minimum": 0,
		"maximum": 22,
		"value": [
			"number",
			"color"
		],
		"length": 2
	},
	"paint": [
		"paint_fill",
		"paint_line",
		"paint_circle",
		"paint_symbol",
		"paint_raster",
		"paint_background"
	],
	"paint_fill": {
		"fill-antialias": {
			"type": "boolean",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"default": true
		},
		"fill-opacity": {
			"type": "number",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"transition": true
		},
		"fill-color": {
			"type": "color",
			"default": "#000000",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				{
					"!": "fill-pattern"
				}
			]
		},
		"fill-outline-color": {
			"type": "color",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				{
					"!": "fill-pattern"
				},
				{
					"fill-antialias": true
				}
			]
		},
		"fill-translate": {
			"type": "array",
			"value": "number",
			"length": 2,
			"default": [
				0,
				0
			],
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"fill-translate-anchor": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "map",
			"requires": [
				"fill-translate"
			]
		},
		"fill-pattern": {
			"type": "string",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"transition": true
		}
	},
	"paint_line": {
		"line-opacity": {
			"type": "number",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"transition": true
		},
		"line-color": {
			"type": "color",
			"default": "#000000",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				{
					"!": "line-pattern"
				}
			]
		},
		"line-translate": {
			"type": "array",
			"value": "number",
			"length": 2,
			"default": [
				0,
				0
			],
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"line-translate-anchor": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "map",
			"requires": [
				"line-translate"
			]
		},
		"line-width": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"line-gap-width": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"line-offset": {
			"type": "number",
			"default": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"line-blur": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"line-dasharray": {
			"type": "array",
			"value": "number",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"minimum": 0,
			"transition": true,
			"units": "line widths",
			"requires": [
				{
					"!": "line-pattern"
				}
			]
		},
		"line-pattern": {
			"type": "string",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"transition": true
		}
	},
	"paint_circle": {
		"circle-radius": {
			"type": "number",
			"default": 5,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"circle-color": {
			"type": "color",
			"default": "#000000",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true
		},
		"circle-blur": {
			"type": "number",
			"default": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true
		},
		"circle-opacity": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true
		},
		"circle-translate": {
			"type": "array",
			"value": "number",
			"length": 2,
			"default": [
				0,
				0
			],
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels"
		},
		"circle-translate-anchor": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "map",
			"requires": [
				"circle-translate"
			]
		},
		"circle-pitch-scale": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "map"
		}
	},
	"paint_symbol": {
		"icon-opacity": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				"icon-image"
			]
		},
		"icon-color": {
			"type": "color",
			"default": "#000000",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				"icon-image"
			]
		},
		"icon-halo-color": {
			"type": "color",
			"default": "rgba(0, 0, 0, 0)",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				"icon-image"
			]
		},
		"icon-halo-width": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels",
			"requires": [
				"icon-image"
			]
		},
		"icon-halo-blur": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels",
			"requires": [
				"icon-image"
			]
		},
		"icon-translate": {
			"type": "array",
			"value": "number",
			"length": 2,
			"default": [
				0,
				0
			],
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels",
			"requires": [
				"icon-image"
			]
		},
		"icon-translate-anchor": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "map",
			"requires": [
				"icon-image",
				"icon-translate"
			]
		},
		"text-opacity": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				"text-field"
			]
		},
		"text-color": {
			"type": "color",
			"default": "#000000",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				"text-field"
			]
		},
		"text-halo-color": {
			"type": "color",
			"default": "rgba(0, 0, 0, 0)",
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"requires": [
				"text-field"
			]
		},
		"text-halo-width": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels",
			"requires": [
				"text-field"
			]
		},
		"text-halo-blur": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels",
			"requires": [
				"text-field"
			]
		},
		"text-translate": {
			"type": "array",
			"value": "number",
			"length": 2,
			"default": [
				0,
				0
			],
			"function": "interpolated",
			"zoom-function": true,
			"property-function": true,
			"transition": true,
			"units": "pixels",
			"requires": [
				"text-field"
			]
		},
		"text-translate-anchor": {
			"type": "enum",
			"function": "piecewise-constant",
			"zoom-function": true,
			"property-function": true,
			"values": [
				"map",
				"viewport"
			],
			"default": "map",
			"requires": [
				"text-field",
				"text-translate"
			]
		}
	},
	"paint_raster": {
		"raster-opacity": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"transition": true
		},
		"raster-hue-rotate": {
			"type": "number",
			"default": 0,
			"period": 360,
			"function": "interpolated",
			"zoom-function": true,
			"transition": true,
			"units": "degrees"
		},
		"raster-brightness-min": {
			"type": "number",
			"function": "interpolated",
			"zoom-function": true,
			"default": 0,
			"minimum": 0,
			"maximum": 1,
			"transition": true
		},
		"raster-brightness-max": {
			"type": "number",
			"function": "interpolated",
			"zoom-function": true,
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"transition": true
		},
		"raster-saturation": {
			"type": "number",
			"default": 0,
			"minimum": -1,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"transition": true
		},
		"raster-contrast": {
			"type": "number",
			"default": 0,
			"minimum": -1,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"transition": true
		},
		"raster-fade-duration": {
			"type": "number",
			"default": 300,
			"minimum": 0,
			"function": "interpolated",
			"zoom-function": true,
			"transition": true,
			"units": "milliseconds"
		}
	},
	"paint_background": {
		"background-color": {
			"type": "color",
			"default": "#000000",
			"function": "interpolated",
			"zoom-function": true,
			"transition": true,
			"requires": [
				{
					"!": "background-pattern"
				}
			]
		},
		"background-pattern": {
			"type": "string",
			"function": "piecewise-constant",
			"zoom-function": true,
			"transition": true
		},
		"background-opacity": {
			"type": "number",
			"default": 1,
			"minimum": 0,
			"maximum": 1,
			"function": "interpolated",
			"zoom-function": true,
			"transition": true
		}
	},
	"transition": {
		"duration": {
			"type": "number",
			"default": 300,
			"minimum": 0,
			"units": "milliseconds"
		},
		"delay": {
			"type": "number",
			"default": 0,
			"minimum": 0,
			"units": "milliseconds"
		}
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/mapbox-gl-style-spec/reference/v8.min.json
 ** module id = 795
 ** module chunks = 0
 **/